import React, { FC, useEffect, useState } from 'react';
import { Loader, Sidebar } from 'components/common';

import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { t } from 'i18next';
import { GetExpensesCat } from 'features/expenses/services/Expenses';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Search from 'components/common/Search';
import NewExpense from './NewExpense';
import { ExpenseCat } from 'features/expenses/types/type';

interface CategoryExpenseProps {
  noteId: number;
  toggleRefresh: () => void;
  toggleRefreshDT?: () => void;
}

const CategoryExpense: FC<SideBarProps<CategoryExpenseProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { closeSidebar, openSidebar } = useSidebarManager();
  const [expenses, setExpenses] = useState<ExpenseCat[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>('');

  const fetchExpenseDetails = async (expenseId: number) => {
    try {
      const response = await GetExpensesCat(expenseId);
      setExpenses(response);
    } catch (error) {
      console.error('Error fetching expense details:', error);
    }
  };

  useEffect(() => {
    if (params.noteId) {
      fetchExpenseDetails(params.noteId);
    }
  }, [params]);

  const handleSearch = (searchValue: string) => {
    setSearchQuery(searchValue.toLowerCase());
  };

  const filteredExpenses = expenses.filter((expense) =>
    expense.name.toLowerCase().includes(searchQuery),
  );

  const handleOpenSidebar = (expenseId: number) => {
    const sidebarData = {
      noteId: params.noteId,
      catId: expenseId,
      toggleRefresh: params.toggleRefresh,
      toggleRefreshDT: params?.toggleRefreshDT,
      expenses: expenses,
    };
    closeSidebar(CategoryExpense);
    openSidebar(NewExpense, false, sidebarData);
  };
  return (
    <Sidebar
      size="m"
      type="secondary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
      className="minthr-sidebar minthr-flex minthr-flex-column minthr-sidebar-m active"
    >
      <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-3">
        <h3>{t('Expenses.cat.list.title')}</h3>
        <button
          className="minthr-sidebar-close"
          type="button"
          onClick={() => closeSidebar(CategoryExpense)}
        >
          <img src="/icons/close.svg" alt="close icon" />
        </button>
      </div>

      <div className="minthr-searchbar minthr-searchbar-s minthr-mb-5">
        <Search
          onSearch={handleSearch}
          placeholder={t('Search')}
          inputClassName="w-100 search"
        />
      </div>
      {!filteredExpenses ? (
        <Loader />
      ) : (
        <div className="row g-0">
          {filteredExpenses.length > 0 &&
            filteredExpenses.map((expense) => (
              <div
                onClick={() => {
                  handleOpenSidebar(expense.id);
                }}
                key={expense.id}
                className={`col-sm-${expense.positive ? 6 : 12} minthr-mb-2`}
              >
                <div
                  className="minthr-flex minthr-flex-items-center minthr-p-2 minthr-border-rounded depense-form-sidebar-open minthr-bg-secondary"
                  style={{ cursor: 'pointer' }}
                >
                  <div
                    className="minthr-icon-bg minthr-icon-bg-m minthr-icon-rounded minthr-mr-2"
                    style={{ backgroundColor: expense.bgColor }}
                  >
                    <i
                      style={{ color: expense.imgColor }}
                      className={expense.imgPath}
                    />
                  </div>
                  <span className="h6 w-100 minthr-text-align-center text-s">
                    {expense.name}
                  </span>
                </div>
              </div>
            ))}
        </div>
      )}
    </Sidebar>
  );
};

export default CategoryExpense;
